import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NovaIcon } from '@rds-nova/angular-icon';

import { SUPPORT_PHONE_NUMBER } from 'src/app/core/constants/support';

@Component({
  selector: 'app-not-authorized',
  imports: [TranslatePipe, NovaIcon],
  templateUrl: './not-authorized.component.html',
  styleUrl: './not-authorized.component.scss',
})
export class NotAuthorized {
  protected readonly phoneNumber = SUPPORT_PHONE_NUMBER;
}
